import React from 'react';
import { withRouter } from 'react-router-dom';

import { Avatar, Layout, Row, Col } from 'antd';

import OrderSearch from './order-search'

import { EEZEE_URL, MKT_BASE_CURRENCY } from '../../index';

import './index.css';

const { Header } = Layout;

class Toolbar extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			onOrdersPage: false
		}
	}

	render() {

		return (
			<Header style={{ background: 'white', padding: "0px 16px" }}>
				<Row justify="space-between" type="flex" gutter={8}>

					<Col >
						{this.state.onOrdersPage && <OrderSearch />}
					</Col>

					<Col>
						<strong>[RESTRICTED] - {MKT_BASE_CURRENCY}</strong>
					</Col>

					<Col>
						<Row type="flex" align="middle" gutter={8}>
							<Col>
								<a target="edit-profile" href={`${EEZEE_URL}/app/profile`}>
									<Avatar icon="user" />
								</a>
							</Col>
						</Row>
					</Col>

				</Row>
			</Header>
		)
	}

	componentWillMount() {
		this.checkIfOnOrdersPage()
	}

	componentDidUpdate(prevProps) {
		if (prevProps.location.pathname != this.props.location.pathname) {
			this.checkIfOnOrdersPage()
		}
	}

	checkIfOnOrdersPage = () => {
		const pathname = this.props.location && this.props.location.pathname

		this.setState({
			onOrdersPage: pathname && pathname.includes('/orders')
		})
	}

}

export default withRouter(Toolbar)


// WEBPACK FOOTER //
// ./src/components/toolbar/index.js